import React, {useState, useEffect, useCallback, useRef} from 'react';
import {
    Container,
    Button,
    Grid,
    CircularProgress,
    TextField, Checkbox, FormControlLabel,
} from '@mui/material';
import { format, parseISO } from 'date-fns'
import { Alert } from '@mui/material';
import {useParams, useHistory} from 'react-router-dom';
import {useForm, Controller} from 'react-hook-form';
import {PeriodService, ReportingGroupService} from '../shared/service';
import ValidationError from "../../shared/ValidationError";
import Prompt from "../../../customUtil/Prompt";
import Select from "react-select";

const ReportingPeriodForm = () => {
    const methods = useForm();
    const {handleSubmit, control, setValue, errors} = methods;

    const [data, setData] = useState({});
    const [message, setMessage] = useState('');
    const [isReady, setIsReady] = useState(false);
    const {id} = useParams();
    const history = useHistory();
    const [block, setBlock] = useState(false);  
    const refSubmitButtom = useRef();
    const [reportingGroups, setReportingGroups] = useState([]);
    
    const [triggerExit, setTriggerExit] = useState({
        onOk: false,
        path: ""
      });
      const [isVisibleDialog, setVisibleDialog] = useState(false);

    const handleGoToIntendedPage = useCallback(
        (location) => history.push(location),
        [history]
      );
      
      useEffect(() => {
        const unblock = history.block((location) => {
          if (location.pathname !== `/gas/account-statements/${id}`) {
            if(block){
                setVisibleDialog(true);   
                setTriggerExit({...triggerExit, path: location.pathname});
            }else{
                setVisibleDialog(false);   
                setTriggerExit({onOk: true, path: location.pathname});
            }
                           
              }
         
          if (triggerExit.onOk) {
            return true;
          }
          return false;
        });
        if (triggerExit.onOk) {
            handleGoToIntendedPage(triggerExit.path);
          }
        return () => {
          unblock();
        };
      }, [history, triggerExit.onOk, triggerExit.path, block]);

    useEffect(() => {

        ReportingGroupService.getAll().then((response) => {
            setReportingGroups(response.data);
        });

        if (id !== "new") {
            PeriodService.getById(id).then((response) => {
                setData(response.data);
                setIsReady(true);
            });
        } else {
            setData({});
            setIsReady(true);
        }
    }, [id, setValue]);


    const onSubmit = d => {
        setBlock(false);
        setVisibleDialog(false);
        const request = {
            ...data, ...d,
            reportingGroup: {id: d.reportingGroup}
        };
        if (data.id) {
            PeriodService.update(request).then((response) => {
                setMessage('Reporting Period updated.')
            });
        } else {
            PeriodService.create(request).then((response) => {
                setData(response.data);
                setMessage('Reporting Period Created.');
            });
        }
    };

    if (!isReady) {
        return (
            <CircularProgress/>
        );
    }
    const triggerSubmit = () => {
        refSubmitButtom?.current?.click();
      };     
   
      const onSave = (event) => {
          console.log(event)
          triggerSubmit();
          setBlock(false);
          setVisibleDialog(false);
      }
  
      const checkModified = (event) => {
          if(event.type ===  "change"){
              setBlock(true);
                 }
              }
              
    return (
        <Container>
            <header>
                <h1>Reporting Period</h1>
            </header>
            {
                message && <Alert severity="success">{message}</Alert>
            }
            <form style={{textAlign: 'left'}} onSubmit={handleSubmit(onSubmit)} onChange={event => {checkModified(event)}}>
            <Prompt
               visible={isVisibleDialog}
               onClose={() => setVisibleDialog(false)}
               onOk={() => {
               setTriggerExit({...triggerExit, onOk: true});
               setVisibleDialog(false);
               setBlock(false);
            }}
               onSave={onSave}
            />
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <p>
                            Reporting periods are periods of interest for generating and sharing grant account
                            statements.
                        </p>
                    </Grid>

                    <Grid item xs={6}>
                        <Controller
                            name="name"
                            control={control}
                            fullWidth
                            as={<TextField></TextField>}
                            label="Name"
                            color="primary"
                            variant="outlined"
                            rules={{required: 'Name is required.'}}
                            defaultValue={data.name}
                        />
                        <ValidationError error={errors.name}/>
                    </Grid>


                    <Grid item xs={6}>
                    </Grid>
                    <Grid item xs={6}>
                        <Controller
                            name="startDate"
                            control={control}
                            fullWidth
                            type='date'
                            as={<TextField InputLabelProps={{ shrink: true }}/>}
                            label="Start Date"
                            color="primary"
                            variant="outlined"
                            rules={{required: 'Start date is required.'}}
                            defaultValue={data.startDate && format(parseISO(data.startDate), 'yyyy-MM-dd')}
                        />
                        <ValidationError error={errors.startDate}/>
                    </Grid>
                    {/*<Grid item xs={6}>*/}
                    {/*</Grid>*/}
                    <Grid item xs={6}>
                        <Controller
                            name="endDate"
                            control={control}
                            type="date"
                            fullWidth
                            as={<TextField InputLabelProps={{ shrink: true }}/>}
                            label="End Date"
                            color="primary"
                            variant="outlined"
                            rules={{required: 'End date is required.'}}
                            defaultValue={data.endDate && format(parseISO(data.endDate), 'yyyy-MM-dd')}
                        />
                        <ValidationError error={errors.endDate}/>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControlLabel label="Reporting Group" variant="outlined" labelPlacement="top"
                                          control={<></>}/>
                        <Controller
                            name="reportingGroup"
                            control={control}
                            label="Reporting Group"
                            rules={{required: 'Reporting Group is required.'}}
                            color="primary"
                            variant="outlined"
                            defaultValue={data.reportingGroup && data.reportingGroup.id}
                            render={(
                                {onChange, onBlur, value, name, ref},
                                {invalid, isTouched, isDirty}
                            ) => (
                                <Select

                                    menuPlacement="auto"
                                    menuPosition="fixed"
                                    options={reportingGroups.map(r => ({value: r.id, label: r.name}))}
                                    value={reportingGroups.map(r => ({
                                        value: r.id,
                                        label: r.name
                                    })).filter(c => value === c.value)}
                                    onChange={val => onChange(val.value)}
                                    inputRef={ref}
                                />
                            )}
                        />
                        <ValidationError error={errors.reportingGroup}/>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControlLabel label="Is Current Period" variant="outlined" control={
                            <Controller
                                name="current"
                                control={control}
                                color="primary"
                                variant="outlined"
                                defaultValue={data.current}
                                render={(
                                    {onChange, onBlur, value, name, ref},
                                    {invalid, isTouched, isDirty}
                                ) => (
                                    <Checkbox
                                        onBlur={onBlur}
                                        onChange={(e) => onChange(e.target.checked)}
                                        checked={value}
                                        inputRef={ref}
                                    />
                                )}
                            />
                        }/>
                    </Grid>

                    {/*<Grid item xs={6}>*/}
                    {/*</Grid>*/}

                    <Grid item xs={12}>
                        <Controller
                            name="periodDocumentFolder"
                            control={control}
                            fullWidth
                            as={<TextField/>}
                            label="Period Document Folder Link"
                            color="primary"
                            variant="outlined"
                            defaultValue={data.periodDocumentFolder}
                        />
                        <ValidationError error={errors.periodDocumentFolder}/>
                    {/*</Grid>*/}
                    {/*<Grid item xs={6}>*/}
                    </Grid>
                    <Grid item xs={12}>
                        <Button variant="contained" color="primary" type="submit">Submit</Button>
                    </Grid>
                </Grid>
                <button hidden={true} ref={refSubmitButtom} type={"submit"} />
            </form>
        </Container>
    );
};

export default ReportingPeriodForm;
